import { inject, Injectable } from '@angular/core';
import { LimitReport } from '@clean-code/models';
import { DataTableParameters, ID, PagingResponse } from '@clean-code/models/common';
import { CanDeactivateTabPageStateService } from '@clean-code/shared/components/ui-can-deactivate-tab-page';
import { EditSearchDataService } from '@clean-code/shared/util/util-data-service';
import { Observable } from 'rxjs';
import { LimitReportPowerService } from './limit-report.service';

@Injectable({ providedIn: 'root' })
export class LimitReportPowerListFacade
  implements EditSearchDataService<LimitReport>
{
  constructor(protected service: LimitReportPowerService) {}

  private canDeactivateTabPageStateService = inject(
    CanDeactivateTabPageStateService,
  );

  public getAll$(
    params: DataTableParameters
  ): Observable<PagingResponse<LimitReport>> {
    return this.service.getAll$(params);
  }

  public getById$(id: ID): Observable<LimitReport> {
    return this.service.getById$(id);
  }

  add$(entity: LimitReport): Partial<Observable<boolean | LimitReport | ID>> {
    throw new Error('Method not implemented.');
  }

  update$(
    entity: LimitReport,
  ): Partial<Observable<boolean | LimitReport | ID>> {
    throw new Error('Method not implemented.');
  }

  delete$(id: ID): Partial<Observable<boolean | void>> {
    return this.service.delete$(id);
  }
}
